module.exports = __webpack_public_path__ + "static/media/synth_01.3572dc25.mp3";